<template>
  <section
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-w-full tw-max-w-lg tw-flex-col tw-items-center lg:tw-max-w-none">
      <h6 class="tw-mb-2" :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'inherit'}`">
        {{ vars.altTitleText }}
      </h6>
      <h2 class="tw-mb-12" :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'inherit'}`">
        {{ vars.titleText }}
      </h2>
      <div class="tw-relative tw-flex tw-h-full tw-w-screen tw-flex-col tw-gap-6">
        <Swiper
          @slideChange="onSlideChange"
          :centered-slides="true"
          :initial-slide="0"
          effect="fade"
          :loop="true"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-w-[100%]"
        >
          <SwiperSlide v-for="(image, index) in images" :key="`image-${index}`">
            <div>
              <library-image
                :src="image.photo"
                :h-ratio="5.3"
                :w-ratio="8"
                image-class="tw-w-full tw-rounded-[var(--rounded)]"
              />
            </div>
          </SwiperSlide>
        </Swiper>

        <div>
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v15"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>
      <nuxt-link
        :external="true"
        :class="`n-${vars.buttonTypeText} n-btn tw-mt-10 tw-self-center`"
        :to="vars.buttonLinkUrl"
        v-if="vars.buttonLinkUrl"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

interface ComponentData {
  swiper: any | null;
  canPaginateBack: boolean;
  isVisible: boolean;
  canPaginateNext: boolean;
}

export default defineNuxtComponent({
  name: 'Theme6ImageGallery',

  mixins: [ComponentMixin],

  data(): ComponentData {
    return {
      swiper: null,
      canPaginateBack: true,
      isVisible: false,
      canPaginateNext: true,
    };
  },

  mounted() {
    try {
      this.onSlideChange();
    } catch (error) {
      console.error('Error in mounted hook:', error);
    }
  },

  computed: {
    images() {
      return this.groupedVariables.images;
    },
  },

  methods: {
    onSwiper(swiper: any) {
      try {
        if (swiper) {
          this.swiper = swiper;
        }
      } catch (error) {
        console.error('Error in onSwiper:', error);
      }
    },

    onSlideChange() {
      try {
        if (!this.swiper) return;

        const isAtStart = this.swiper.isBeginning;
        const isAtEnd = this.swiper.isEnd;

        this.canPaginateBack = true;
        this.canPaginateNext = true;
      } catch (error) {
        console.error('Error in onSlideChange:', error);
      }
    },
  },
});
</script>
